import {
  ActionReducer,
  ActionReducerMap,
  createFeatureSelector,
  createSelector,
  MetaReducer
} from '@ngrx/store';
import { environment } from '../../environments/environment';
import * as authReducer from 'src/app/modules/auth/state/reducer';
import * as userMapReducer from 'src/app/state/userMap.reducer';
import * as setupsReducer from 'src/app/modules/setups/state/setups.reducer';

export interface AppState {
  [authReducer.AuthFeatureKey]: authReducer.AuthState | undefined;
  [userMapReducer.UserMappingFeatureKey]: userMapReducer.UserMappingState | undefined;
  [setupsReducer.SetupsFeatureKey]: setupsReducer.SetupsState | undefined;
}

export const reducers: ActionReducerMap<AppState> = {
  [authReducer.AuthFeatureKey]: authReducer.reducer,
  [userMapReducer.UserMappingFeatureKey]: userMapReducer.reducer,
  [setupsReducer.SetupsFeatureKey]: setupsReducer.SetupsReducer
};


export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [] : [];
